import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Snippet from './TableSnippet';
import "../../../styles/expansionPanelSnippet.css";


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function SimpleExpansionPanel({SelectedConcept, Link, Title}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ExpansionPanel>
        <ExpansionPanelSummary
            className="expansionTitle"
            expandIcon={<ExpandMoreIcon className="svg_icon"/>}
            aria-controls="panel1a-content"
            id="panel1a-header"
        >
          <Typography className={classes.heading}>Part of text which contains <strong>{SelectedConcept.replace("http://dbpedia.org/resource/",'').replace('_',' ').replace('_',' ').replace('_',' ')}</strong></Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <Snippet SelectedConcept = {SelectedConcept} Link = {Link}/>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}